import { useExperiments } from '@hc-frontend/core-ui';
import { ButtonWithTracking } from '@hc-frontend/shells-shared';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

import type { SurveyPlateTransitionOptionsProps } from './survey-plate-transition-options.types';

export function SurveyPlateTransitionOptions({
  continueButtonLabel = 'Continue',
  backButtonLabel = 'Back',
  continueButtonDisabled,
  metricTags,
  handleSkipClick,
  isRequired = false,
  showBackButton = false,
  showContinueButton = true,
  isPending,
}: SurveyPlateTransitionOptionsProps) {
  const router = useRouter();
  const experiments = useExperiments();

  useEffect(() => {
    const element = document.getElementById('plate-animation-container');
    element?.classList.toggle('animate-plate-pulse', isPending);
  }, [isPending]);

  if (
    experiments.mp_719_mobile_full_width_continue_btn_o65 === 'variant' ||
    experiments.mp_739_mobile_full_width_continue_btn_u65 === 'variant'
  ) {
    return (
      <>
        <div className="h-[40dvh] tablet:h-0" />
        <div className="hc-container-layout--exclude fixed inset-x-0 bottom-0 border-t border-gray-50 bg-gray-0 px-16-16 py-12-12 tablet:static tablet:border-t-0">
          <div className="p-safe flex w-full items-center justify-center">
            <ButtonWithTracking
              id="next-button"
              variant="primary-card"
              type="submit"
              className="w-full justify-center px-32-60 text-center tablet:w-fit"
              disabled={isPending || continueButtonDisabled}
              metricTags={metricTags}
              name="action"
              value="continue"
            >
              {continueButtonLabel}
            </ButtonWithTracking>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="hc-center-layout hc-stack-layout my-16-16">
      <div className="hc-center-layout my-16-16 flex flex-col flex-wrap justify-center gap-12-12">
        {showContinueButton ? (
          <ButtonWithTracking
            id="next-button"
            variant="primary-card"
            type="submit"
            className="px-32-60"
            disabled={isPending || continueButtonDisabled}
            metricTags={metricTags}
            name="action"
            value="continue"
          >
            {continueButtonLabel}
          </ButtonWithTracking>
        ) : null}
        {showBackButton ? (
          <ButtonWithTracking
            id="back-button"
            variant="text"
            type="button"
            className="font-regular text-gray-400 underline"
            disabled={isPending}
            metricTags={metricTags}
            onClick={() => {
              router.back();
            }}
          >
            {backButtonLabel}
          </ButtonWithTracking>
        ) : null}
      </div>

      {!isRequired ? (
        <ButtonWithTracking
          id="skip-button"
          variant="text"
          type="submit"
          className="font-regular text-gray-400 underline"
          metricTags={metricTags}
          disabled={isPending}
          onClick={(event) => {
            if (handleSkipClick) {
              handleSkipClick(event);
            }
          }}
          name="action"
          value="skip"
        >
          Skip
        </ButtonWithTracking>
      ) : null}
    </div>
  );
}

export default SurveyPlateTransitionOptions;
